'use client';
import Typography from '@/components/shared/typography/typography.component';
import Modal from '@/components/shared/modal.component';
import SylndrButton from '@/components/shared/Button/button-styled.component';
import React, { FC, useState } from 'react';
import { useAppDispatch, useTranslation, useWindowDimensions } from '@/hook';

import { GreenInfo } from '../../../../public/Images';
import NotifyMe from '@/components/car-details/CarProfileNew/NotifyMe';
import { useAnalytics } from '@/integrations';
import { AllowedVehicleBookingTypes, DisplayedCarInfoInterface } from '@/types';
import Image from 'next/image';
import Link from '@/components/WrappedLink';
import { toggleLoading } from '@/redux/reducers/checkoutReducer';

const ReserveSeeCarButtons: FC<{
    carInfo: DisplayedCarInfoInterface;
    inCarInfoCard: boolean;
}> = ({ carInfo, inCarInfoCard = false }) => {
    const { t, i18n } = useTranslation();
    const { IS_DESKTOP } = useWindowDimensions();
    const { trackEvent } = useAnalytics();
    const [notifyMeModal, setNotifyModal] = useState(false);
    const dispatch = useAppDispatch();

    return (
        <div>
            {' '}
            {IS_DESKTOP && (
                <>
                    {' '}
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '16px',
                            height: '60px',
                        }}
                    >
                        {carInfo?.bookingType !==
                            AllowedVehicleBookingTypes.SEE_ONLY &&
                            (carInfo?.isReserved ? (
                                <button
                                    style={{
                                        width: '100%',
                                        borderColor: '#D0D5DD',
                                        backgroundColor: 'white',
                                        borderRadius: '8px',
                                        borderWidth: '1px',
                                        height: '44px',
                                        outline: 'none',
                                        border: ' 1px solid #D0D5DD',
                                    }}
                                    onClick={() => setNotifyModal(true)}
                                >
                                    <Typography
                                        variant="body1Medium"
                                        style={{ color: 'black' }}
                                    >
                                        {t('Notify Me')}
                                    </Typography>
                                </button>
                            ) : (
                                carInfo?.id !== undefined && (
                                    <Link
                                        href={`/${i18n.language}/car-details/${carInfo?.id}/checkout/reserve?carId=${carInfo?.id}`}
                                        style={{
                                            textDecoration: 'none',
                                            width: '100%',
                                            height: '44px',
                                        }}
                                    >
                                        <SylndrButton
                                            onClick={() => {
                                                trackEvent(
                                                    'Action: Reserve Car',
                                                    {
                                                        carName:
                                                            carInfo.carName,
                                                        newlyAdded:
                                                            carInfo.isNewlyAdded &&
                                                            !(
                                                                carInfo.isReserved ||
                                                                carInfo.isPurchaseInProgress
                                                            ),
                                                        status: carInfo.isPurchaseInProgress
                                                            ? 'Being Sold'
                                                            : carInfo.isReserved
                                                            ? 'Reserved'
                                                            : 'Not Reserved',
                                                    }
                                                );
                                                dispatch(toggleLoading(false));
                                            }}
                                            variant={'primary'}
                                            disabled={carInfo?.isReserved}
                                        >
                                            <Typography variant="body1SemiBold">
                                                {t('reserve car')}
                                            </Typography>
                                        </SylndrButton>
                                    </Link>
                                )
                            ))}

                        {carInfo?.id !== undefined &&
                            carInfo?.bookingType !==
                                AllowedVehicleBookingTypes.RESERVE_ONLY && (
                                <Link
                                    href={`/${i18n.language}/car-details/${carInfo?.id}/checkout/see?carId=${carInfo?.id}`}
                                    style={{
                                        textDecoration: 'none',
                                        width: '100%',
                                        height: '44px',
                                    }}
                                >
                                    <SylndrButton
                                        onClick={() => {
                                            trackEvent('Action: Book Visit', {
                                                carName: carInfo.carName,
                                                newlyAdded:
                                                    carInfo.isNewlyAdded &&
                                                    !(
                                                        carInfo.isReserved ||
                                                        carInfo.isPurchaseInProgress
                                                    ),
                                                status: carInfo.isPurchaseInProgress
                                                    ? 'Being Sold'
                                                    : carInfo.isReserved
                                                    ? 'Reserved'
                                                    : 'Not Reserved',
                                            });
                                            dispatch(toggleLoading(false));
                                        }}
                                        variant={'secondary'}
                                    >
                                        <Typography variant="body1SemiBold">
                                            {t('See Car')}
                                        </Typography>
                                    </SylndrButton>
                                </Link>
                            )}
                    </div>
                    {carInfo?.bookingType !==
                        AllowedVehicleBookingTypes.SEE_ONLY &&
                    carInfo?.isReserved &&
                    inCarInfoCard ? (
                        <div
                            style={{
                                display: 'flex',
                                padding: '10px',
                                backgroundColor: '#ECFDF3',
                                borderRadius: '8px',
                                gap: '6px',
                                alignItems: 'flex-start',
                                alignContent: 'center',
                                justifyContent: 'center',
                                width: '100%',
                                marginTop: '16px',
                            }}
                        >
                            <Image
                                src={GreenInfo}
                                alt="GreenInfo"
                                width={20}
                                height={20}
                            />
                            <Typography
                                variant="captionMedium"
                                style={{ color: '#039855' }}
                            >
                                {t(
                                    'Clicking on Notify Me will send you a message once the the car is open for reservation again'
                                )}
                            </Typography>
                        </div>
                    ) : null}
                </>
            )}
            {carInfo?.bookingType !== AllowedVehicleBookingTypes.SEE_ONLY && (
                <Modal
                    open={notifyMeModal}
                    sx={{ backdropFilter: 'blur(6px)', borderRadius: '12px' }}
                    setOpen={setNotifyModal}
                >
                    <NotifyMe setModal={setNotifyModal} carId={carInfo?.id} />
                </Modal>
            )}
        </div>
    );
};

export default ReserveSeeCarButtons;
